<template>
  <div>
    <el-container :style="rowHeight">
      <el-aside class="left_nav">
        <ul>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#icon')">Icon图标</a>
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#Link')"
              >Link 文字链接</a
            >
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#Button')"
              >Button 按钮</a
            >
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#ksfw')">快速访问</a>
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#top_right')"
              >顶部右上角头像、图片</a
            >
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#meeting_left_nav')"
              >会议左侧菜单</a
            >
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#meeting_list')"
              >会议中心列表</a
            >
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#meeting_from')"
              >会议中心表单</a
            >
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#vote_left_nav')"
              >投票左侧菜单</a
            >
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#baseInfo')"
              >投票中心基本信息</a
            >
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#common_list')"
              >通用列表样式</a
            >
          </li>
          <li>
            <a href="javascript:void(0)" @click="goAnchor('#common_from')"
              >通用表单样式</a
            >
          </li>
        </ul>
        <div class="home_fee_box">
          <span><i class="iconfont icon-huiyuan2"></i>剩余会议场次：6</span>
          <el-link type="primary" :underline="false">购买</el-link>
        </div>
      </el-aside>
      <el-main id="main">
        <el-divider id="icon" content-position="left">Icon图标</el-divider>
        <div>
          <h5>element ui</h5>
          <el-link
            href="https://element.eleme.io/#/zh-CN/component/icon"
            target="_blank"
            >https://element.eleme.io/#/zh-CN/component/icon</el-link
          >
          <h5>iconfont：</h5>
          <el-image
            style="width: 100px; height: 100px"
            :src="url"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
        <el-divider id="Link" content-position="left">Link 文字链接</el-divider>
        <div>
          <el-link>默认链接</el-link><br />
          <el-link type="primary">主要链接</el-link><br />
          <el-link type="success">成功链接</el-link><br />
          <el-link type="warning">警告链接</el-link><br />
          <el-link type="danger">危险链接</el-link><br />
          <el-link type="info">信息链接</el-link>
        </div>
        <el-divider id="Button" content-position="left">Button 按钮</el-divider>
        <div>
          <el-row>
            <el-button>默认按钮</el-button>
            <el-button type="primary">主要按钮</el-button>
            <el-button type="success">成功按钮</el-button>
            <el-button type="info">信息按钮</el-button>
            <el-button type="warning">警告按钮</el-button>
            <el-button type="danger">危险按钮</el-button>
          </el-row>
          <br />
          <el-row>
            <el-button plain>朴素按钮</el-button>
            <el-button type="primary" plain>主要按钮</el-button>
            <el-button type="success" plain>成功按钮</el-button>
            <el-button type="info" plain>信息按钮</el-button>
            <el-button type="warning" plain>警告按钮</el-button>
            <el-button type="danger" plain>危险按钮</el-button>
          </el-row>
          <br />
          <el-row>
            <el-button round>圆角按钮</el-button>
            <el-button type="primary" round>主要按钮</el-button>
            <el-button type="success" round>成功按钮</el-button>
            <el-button type="info" round>信息按钮</el-button>
            <el-button type="warning" round>警告按钮</el-button>
            <el-button type="danger" round>危险按钮</el-button>
          </el-row>
          <br />
          <el-row>
            <el-button icon="el-icon-search" circle></el-button>
            <el-button type="primary" icon="el-icon-edit" circle></el-button>
            <el-button type="success" icon="el-icon-check" circle></el-button>
            <el-button type="info" icon="el-icon-message" circle></el-button>
            <el-button
              type="warning"
              icon="el-icon-star-off"
              circle
            ></el-button>
            <el-button type="danger" icon="el-icon-delete" circle></el-button>
          </el-row>
        </div>
        <el-divider id="ksfw" content-position="left">快速访问</el-divider>
        <div
          style="
            height: 56px;
            background-color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <div
            class="mask"
            v-if="isQuickShow"
            @click="isQuickShow = false"
          ></div>
          <div class="quick">
            <div
              @click="quickClick"
              :class="
                this.isQuickShow
                  ? 'quick_event_list_bar_show'
                  : 'quick_event_list_bar'
              "
            >
              <span class="span_tip quick_event_list_bar_tip">2</span>
              <span>最近访问</span>
              <span
                ><i
                  class="el-icon-arrow-down"
                  :style="
                    this.isQuickShow
                      ? 'transform: rotate(-180deg);transition: all .5s'
                      : 'transform: rotate(0deg);transition: all .5s'
                  "
                ></i
              ></span>
            </div>
            <el-collapse-transition>
              <div class="quick_event_list" v-show="this.isQuickShow">
                <el-table
                  :data="tableData"
                  style="width: 100%"
                  :show-header="false"
                >
                  <el-table-column
                    ><template slot-scope="scope">
                      <div>
                        <span
                          class="quick_event_list_item"
                          :title="scope.row.cityFleetid"
                          >{{ scope.row.address }}
                        </span>
                      </div>
                      <div>
                        {{ scope.row.date }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" width="80"
                    ><template slot-scope="scope"
                      ><div class="quick_event_list_state">
                        <span class="span_tip end_bg_color">{{
                          scope.row.name
                        }}</span>
                      </div></template
                    ></el-table-column
                  >
                </el-table>
                <div class="quick_event_list_btns">
                  <el-button>查看全部项目</el-button>
                  <el-button type="primary">创建</el-button>
                </div>
              </div>
            </el-collapse-transition>
          </div>
        </div>
        <el-divider id="top_right" content-position="left"
          >顶部右上角头像、图片</el-divider
        >
        <div
          style="
            height: 56px;
            background-color: #fff;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          "
        >
          <div
            style="
              padding: 5px 0px;
              display: -webkit-flex;
              /* Safari */
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: center;
            "
          >
            <el-link icon="iconfont icon-bangzhu" :underline="false"></el-link>
            <el-link
              icon="iconfont icon-xiaoxizhongxin"
              :underline="false"
            ></el-link>
            <div class="nav_avatar_box">
              <el-avatar
                size="medium"
                src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                >user</el-avatar
              >
              <span>13269019917</span>
            </div>
          </div>
        </div>
        <el-divider id="meeting_left_nav" content-position="left"
          >会议左侧菜单</el-divider
        >
        <div style="width: 200px">
          <el-menu default-active="2" class="el-menu-vertical-demo">
            <el-menu-item index="1"
              ><template slot="title">
                <i class="iconfont icon-huiyizhongxin-toupiao"></i>
                <span>会议中心</span>
              </template></el-menu-item
            >
            <el-menu-item index="2"
              ><template slot="title">
                <i class="iconfont icon-yonghuguanli"></i>
                <span>个人中心</span>
              </template></el-menu-item
            >
            <el-menu-item index="3"
              ><template slot="title">
                <i class="iconfont icon-chongzhizhongxin"></i>
                <span>充值中心</span>
              </template></el-menu-item
            >
            <el-menu-item index="4"
              ><template slot="title">
                <i class="iconfont icon-yonghuguanli"></i>
                <span>用户管理</span>
              </template></el-menu-item
            >
          </el-menu>
        </div>
        <el-divider id="meeting_list" content-position="left"
          >会议中心列表</el-divider
        >
        <h2>会议中心</h2>
        <div class="meeting_list_box">
          <el-tabs v-model="activeName" @tab-click="tabClick">
            <el-tab-pane label="全部" name="all"></el-tab-pane>
            <el-tab-pane label="编辑中" name="edit"></el-tab-pane>
            <el-tab-pane label="已发布" name="publish"></el-tab-pane>
            <el-tab-pane label="已结束" name="end"></el-tab-pane>
            <el-tab-pane label="已归档" name="close"></el-tab-pane>
          </el-tabs>
          <div class="meeting_list_search">
            <el-input
              placeholder="请输入内容"
              v-model="query.keyWord"
              prefix-icon="el-icon-search"
              class="meeting_list_search_input"
            >
              <el-button slot="append">查询</el-button>
            </el-input>
            <el-button type="primary"
              >创建<i class="el-icon-circle-plus-outline el-icon--right"></i
            ></el-button>
          </div>
          <el-table
            :data="tableData"
            @cell-mouse-enter="cellMouseEnter"
            @cell-mouse-leave="cellMouseLeave"
            style="width: 100%"
          >
            <el-table-column prop="address" label="会议"> </el-table-column>
            <el-table-column label="状态" width="180">
              <template slot-scope="scope">
                <el-button type="primary" v-show="scope.row.isShowBtn"
                  >编辑</el-button
                >
                <span v-show="!scope.row.isShowBtn">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="时间" width="280">
              <template slot-scope="scope">
                <div class="meeting_list_btn_box" v-show="scope.row.isShowBtn">
                  <div class="meeting_list_btn_box_btn">
                    <span><i class="iconfont icon-bian-ji"></i></span>
                    <span>编辑</span>
                  </div>
                  <!-- <div class="meeting_list_btn_box_btn">
                    <span><i class="iconfont icon-shanchu"></i></span>
                    <span>删除</span>
                  </div> -->
                  <div class="meeting_list_btn_box_btn">
                    <span><i class="iconfont icon-erweima"></i></span>
                    <span>二维码</span>
                  </div>
                  <div class="meeting_list_btn_box_btn">
                    <span><i class="iconfont icon-xiaochengxu"></i></span>
                    <span>小程序</span>
                  </div>
                </div>
                <span v-show="!scope.row.isShowBtn">{{ scope.row.date }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-divider id="meeting_from" content-position="left"
          >会议中心表单</el-divider
        >
        <div>
          <el-button type="primary" @click="dialogFormVisible = true"
            >会议表单</el-button
          >
          <el-dialog title="新建会议" :visible.sync="dialogFormVisible">
            <el-form :model="form" class="demo-form">
              <el-form-item
                label="会议名称"
                :label-width="formLabelWidth"
                required
              >
                <el-input
                  v-model="form.name"
                  placeholder="发布会议后会议名称不能修改"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="开始时间"
                :label-width="formLabelWidth"
                required
              >
                <el-col :span="11">
                  <el-form-item>
                    <el-date-picker
                      type="date"
                      placeholder="选择开始日期"
                      v-model="form.date1"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-form-item>
                    <el-time-picker
                      placeholder="选择开始时间"
                      v-model="form.date2"
                      style="width: 100%"
                    ></el-time-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item label="会议类型" :label-width="formLabelWidth">
                <el-select v-model="form.type" placeholder="请选择会议类型">
                  <el-option label="类型一" value="shanghai"></el-option>
                  <el-option label="类型二" value="beijing"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="会议简介" :label-width="formLabelWidth">
                <el-input type="textarea" v-model="form.desc"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible = false"
                >确 定</el-button
              >
            </div>
          </el-dialog>
        </div>
        <el-divider id="vote_left_nav" content-position="left"
          >投票左侧菜单</el-divider
        >
        <div style="width: 200px">
          <el-menu default-active="2" class="el-menu-vertical-demo">
            <el-menu-item index="1"
              ><template slot="title">
                <i class="iconfont icon-jibenxinxi"></i>
                <span>基本信息</span>
              </template></el-menu-item
            >
            <el-menu-item index="2"
              ><template slot="title">
                <i class="iconfont icon-pingweiguanli"></i>
                <span>投票人员</span>
              </template></el-menu-item
            >
            <el-menu-item index="3"
              ><template slot="title">
                <i class="iconfont icon-zu"></i>
                <span>待评项目</span>
              </template></el-menu-item
            >
            <el-menu-item index="4"
              ><template slot="title">
                <i class="iconfont icon-huaban"></i>
                <span>投票管理</span>
              </template></el-menu-item
            >
          </el-menu>
          <div class="vote_nav_notice_box">
            <a><i class="iconfont icon-huiyitongzhi"></i>会议通知</a>
          </div>
          <div class="vote_nav_QRCode">
            <div class="code_tip">二维码</div>
            <el-image
              style="width: 180px; height: 180px"
              :src="wxUrl"
              :preview-src-list="wxSrcList"
            >
            </el-image>
            <el-image
              style="width: 180px; height: 180px"
              :src="webUrl"
              :preview-src-list="webSrcList"
            >
            </el-image>
          </div>
        </div>
        <el-divider id="baseInfo" content-position="left"
          >投票中心基本信息</el-divider
        >
        <h4>基本信息</h4>
        <div class="vote_content_box">
          <el-form :model="form" class="demo-form">
            <el-form-item
              label="会议名称"
              :label-width="formLabelWidth"
              required
            >
              <el-input
                v-model="form.name"
                placeholder="发布会议后会议名称不能修改"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="开始时间"
              :label-width="formLabelWidth"
              required
            >
              <el-col :span="11">
                <el-form-item>
                  <el-date-picker
                    type="date"
                    placeholder="选择开始日期"
                    v-model="form.date1"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-time-picker
                    placeholder="选择开始时间"
                    v-model="form.date2"
                    style="width: 100%"
                  ></el-time-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="会议类型" :label-width="formLabelWidth">
              <el-select v-model="form.type" placeholder="请选择会议类型">
                <el-option label="类型一" value="shanghai"></el-option>
                <el-option label="类型二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="会议简介" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="form.desc"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <el-divider id="common_list" content-position="left"
          >通用列表样式</el-divider
        >
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column prop="date" label="日期" width="180">
          </el-table-column>
          <el-table-column prop="name" label="姓名" width="180">
          </el-table-column>
          <el-table-column prop="address" label="地址"> </el-table-column>
        </el-table>
        <el-divider id="common_from" content-position="left"
          >通用表单样式</el-divider
        >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="活动区域" prop="region">
            <el-select v-model="ruleForm.region" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动时间" required>
            <el-col :span="11">
              <el-form-item prop="date1">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="ruleForm.date1"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-time-picker
                  placeholder="选择时间"
                  v-model="ruleForm.date2"
                  style="width: 100%"
                ></el-time-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="即时配送" prop="delivery">
            <el-switch v-model="ruleForm.delivery"></el-switch>
          </el-form-item>
          <el-form-item label="活动性质" prop="type">
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
              <el-checkbox label="地推活动" name="type"></el-checkbox>
              <el-checkbox label="线下主题活动" name="type"></el-checkbox>
              <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="特殊资源" prop="resource">
            <el-radio-group v-model="ruleForm.resource">
              <el-radio label="线上品牌商赞助"></el-radio>
              <el-radio label="线下场地免费"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动形式" prop="desc">
            <el-input type="textarea" v-model="ruleForm.desc"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >立即创建</el-button
            >
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      rowHeight: {
        height: window.innerHeight - 108 + 'px'
      },
      url: require('../assets/images/iconList.png'),
      srcList: [
        require('../assets/images/iconList.png')
      ],
      wxUrl: 'https://kaifa2001.suizhi.com/resource/upload/946eb228-6820-4d8f-b187-6b760f9cd8fbvotewx.jpg',
      wxSrcList: [
        'https://kaifa2001.suizhi.com/resource/upload/946eb228-6820-4d8f-b187-6b760f9cd8fbvotewx.jpg'
      ],
      webUrl: 'https://kaifa2001.suizhi.com/resource/upload/946eb228-6820-4d8f-b187-6b760f9cd8fbvote.jpg',
      webSrcList: [
        'https://kaifa2001.suizhi.com/resource/upload/946eb228-6820-4d8f-b187-6b760f9cd8fbvote.jpg'
      ],
      isQuickShow: false,
      activeName: 'all',
      query: {
        keyWord: null
      },
      tableData: [{
        isShowBtn: false,
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄'
      }, {
        isShowBtn: false,
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }],
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '120px',
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        date1: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        date2: [
          { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        ],
        type: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' }
        ],
        desc: [
          { required: true, message: '请填写活动形式', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    goAnchor: function (type) {
      const anchor = this.$el.querySelector(type)
      // chrome
      document.getElementById('main').scrollTop = anchor.offsetTop - 120
    },
    tabClick (tab, event) {
      if (tab.name === 'all') {
        this.tableData = [{
          isShowBtn: false,
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄上海市普陀区金沙江路 1518 弄'
        }, {
          isShowBtn: false,
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }]
      }
      if (tab.name === 'edit') {
        this.tableData = []
      }
      if (tab.name === 'publish') {
        this.tableData = null
      }
    },
    cellMouseEnter: function (row, column, cell, event) {
      console.log(row, column, cell, event)
      row.isShowBtn = true
    },
    cellMouseLeave: function (row, column, cell, event) {
      console.log(row, column, cell, event)
      row.isShowBtn = false
    },
    quickClick: function () {
      this.isQuickShow = !this.isQuickShow
    }
  }
}
</script>

<style lang="less">
//
</style>
